<template>
  <div>
    <div :class="`${bottom ? 'pb-32' : ''}`">
      <slot />
    </div>
    <LayoutBottom v-if="bottom" />
  </div>
</template>
<script>

import LayoutBottom from './bottom';

export default {
  components: {
    LayoutBottom,
  },
  props: {
    authUser: {
      default: () => { },
      type: Object,
    },
    bottom: {
      default: true,
      type: Boolean,
    },
  },
};
</script>
